@if (!isCheckoutPage) {
  @if ((onlineOrdering$|async) && !(isOrderBlocked$|async)) {
    <button (click)="showContent = !showContent" class="quick-order-btn">
      <img src="/images/quickOrder_grey.png" alt="">
      <span class="quickText">{{'common.header_quick_order'|cxTranslate}}</span>
    </button>
  }
  @if (showContent) {
    <div class="showContent">
      <nav>
        <div>
          <a (click)="showContent = !showContent" [routerLink]="'/quickOrderPage'" title="Quick Order Form">
          {{'common.text_quick_order_form'|cxTranslate}}</a>
        </div>
        <div>
          <a (click)="showContent = !showContent" [routerLink]="'/importCSVSavedCartPage'" title="Import Order">
          {{'common.text_import_order'|cxTranslate}}</a>
        </div>
      </nav>
    </div>
  }
}